import { createSlice } from '@reduxjs/toolkit';
import { loginTelegram } from './auth.thunk';
import { saveToken, loadToken, clearToken } from '@/shared/lib/tokenStorage';

interface AuthState {
  isAuth: boolean;
  status: 'ACTIVE' | 'UNREGISTERED' | 'BANNED' | null;
  selectedGender: 'male' | 'female';
  accessToken: string | null;
  loading: boolean;
  error: string | null;
}

// Load token from multiple sources (priority order):
// 1. URL parameter (dev/testing mode with ?token=xxx)
// 2. localStorage (dev/staging mode, survives refresh)
const devToken = (window as any).__INITIAL_AUTH_TOKEN__ || null;
const storedToken = loadToken();
const initialToken = devToken || storedToken;

// Сохраняем токен из URL в localStorage для persistence
if (devToken && !storedToken) {
  saveToken(devToken);
}

const initialState: AuthState = {
  isAuth: !!initialToken,
  status: initialToken ? 'ACTIVE' : null,
  selectedGender: 'male',
  accessToken: initialToken,
  error: null,
  loading: false,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    login: (state) => {
      state.isAuth = true;
    },
    logout: (state) => {
      state.isAuth = false;
      state.accessToken = null;
      state.status = null;
      clearToken();
    },
    selectGender: (state, action: { payload: 'male' | 'female' }) => {
      state.selectedGender = action.payload;
    },
    setAuthToken: (state, action: { payload: string }) => {
      state.accessToken = action.payload;
      state.isAuth = true;
      state.status = 'ACTIVE';
      saveToken(action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loginTelegram.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder
      .addCase(loginTelegram.fulfilled, (state, action) => {
        state.loading = false;
        state.status = action.payload.case;

        if (action.payload.case === 'ACTIVE') {
          state.isAuth = true;
          state.accessToken = action.payload.accessToken || null;

          // Сохраняем токен в localStorage (только для dev/staging)
          if (action.payload.accessToken) {
            saveToken(action.payload.accessToken);
          }
        } else {
          state.isAuth = false;
          state.accessToken = null;
          clearToken(); // Очищаем токен при неуспешной авторизации
        }
      })

      .addCase(loginTelegram.rejected, (state, action) => {
        state.loading = false;
        state.isAuth = false;
        state.error = action.payload?.message || 'Ошибка авторизации';
      });
  },
});

export const { login, logout, selectGender, setAuthToken } = authSlice.actions;
export default authSlice.reducer;
